// extracted by mini-css-extract-plugin
export default {"heading":"BreadCrumb_heading__khOAg","text":"BreadCrumb_text__cirrN","icon":"BreadCrumb_icon__f9DQ7","active":"BreadCrumb_active__Py8CC","done":"BreadCrumb_done__9nn4v"};